import { PopupPanelVm } from "../../panels/popup-panel-vm";
import { Lazy } from "../lazy";
import { DebuggingDiffDialogGridVm } from "./debugging-diff-dialog-grid-vm";
import { Debugging } from "./debugging";
import { IDirtyResult, ICaptureItem } from "../../extend/dirty-flag";
import { diff } from "../../extend/diff";

export class DebuggingDiffDialogVm extends PopupPanelVm {
	public static getInstance = Lazy.singleton(DebuggingDiffDialogVm);

	constructor() {
		super();
		this.applyPopupOptions({
			title: "Änderungen",
			width: "80%",
			height: "80%",
			hideOnOutsideClick: (e: any) => {
				if ($(e.target).parents(".dx-popup-normal").length === 0 && $(e.target).parents(".dx-submenu").length === 0) {
					return true;
				}
				return false;
			},
		});
	}

	public grid = new DebuggingDiffDialogGridVm();

	public async showAsync() {

		let dataSource = [];
		let data = Debugging.getInstance().data;

		for (let name of Object.keys(data)) {
			let element = data[name];
			let dirtyFlag: IDirtyResult = element && element.raw && element.raw.dirtyFlag;

			let getWithFullQualifiedPath = (items: ICaptureItem[]) => {

				let currentPath = "";
				let paths: string[] = [];

				let pushPath = (path: string) => {
					if (currentPath) {
						path = `.${path}`;
					}
					paths.push(currentPath);
					if (currentPath.endsWith(path + "[..]")) {
						return;
					}
					currentPath += path;
				};

				let popPath = () => {
					currentPath = paths.pop();
				};

				let result: ICaptureItem[] = [];

				pushPath(name);

				for (let item of items) {
					switch (item.key) {
						case "$push-arr":
							pushPath(item.value + "[..]");
							break;

						case "$push-dto":
							pushPath(item.value);
							break;

						case "$pop-arr":
						case "$pop-dto":
							popPath();
							break;

						default:
							pushPath(item.key);
							result.push({ key: currentPath, value: item.value });
							popPath();
							break;
					}
				}

				popPath();

				return result;
			};

			if (dirtyFlag) {
				let { initial, current } = dirtyFlag.getDiff();
				let fullInitial = getWithFullQualifiedPath(initial);
				let fullCurrent = getWithFullQualifiedPath(current);

				let diffResult = diff(fullInitial, fullCurrent, (a, b) => a.key === b.key && a.value === b.value);

				for (let item of diffResult) {
					dataSource.push({
						id: dataSource.length,
						source: name,
						change: item.type,
						key: item.value.key,
						value: item.value.value,
					});
				}
			}
		}

		this.grid.dataSource(dataSource);

		this.show();
	}

	protected initialize(): void { }
}